<template>
    <div class="page article-detail">
        <article-detail-skeleton v-if="loading" style="margin-bottom: 100vh"></article-detail-skeleton>

        <div class="article-detail-box">
            <h3 class="article-detail-title">{{ article.title }}</h3>
            <div style="padding: 0 15px 15px">
                <div class="article-detail-time">{{ article.created_at }} 阅读 {{ article.view_count }}</div>
            </div>
            <div class="clear" style="margin-top: 15px"></div>

            <div>
                <ExpertInfo :acceptData="article.professors" />

                <div class="article-detail-content">
                    <div class="rich_media_inner" v-html="article.content"></div>
                </div>
            </div>
        </div>
        <div class="line"></div>

        <div class="comment" style="margin-top: 10px">
            <div class="comment-title">评论</div>
            <div class="comment-section" v-for="item in comment" :key="item.id">
                <div class="comment-section-photo">
                    <img :src="item.avatar" alt="" />
                </div>
                <div class="comment-section-content">
                    <div class="comment-section-content-author" @click="reComment(item)">{{ item.name }}</div>
                    <div class="comment-section-content-detail" @click="reComment(item)" v-html="item.content.replace(/\\x(\d{1,2})/g,'<img style=\'width:22px\' src=&quot;https://static.mudu.tv/assets/img-console/activity/face/$1.png&quot; />')"></div>
                    <div class="comment-section-content-bottom">
                        <div class="comment-section-content-time">{{ item.created_at }}</div>
                        <div class="comment-section-content-point" @click="pointLikeComment(item)">
                            <span v-if="item.isLike"><van-icon name="/static/img/course/icon_course_like_on.svg"/></span>
                            <span v-else><van-icon name="/static/img/course/icon_course_like_off.svg"/></span>
                            {{ item.like_count == 0 ? '赞' : item.like_count }}
                        </div>
                        <div class="clear"></div>
                        <div class="comment-section-content-children" v-if="item.children != null && item.children.length > 0">
                            <div v-for="(val, valIndex) in item.children" :key="valIndex">
                                <span @click="reCommentChild(val)">{{ val.name }}</span>
                                <span style="color: #404040" v-if="val.reply_name != ''"> 回复 </span>
                                <span @click="reCommentChild(val)">{{ val.reply_name }}</span>：<span v-html="val.content.replace(/\\x(\d{1,2})/g,'<img src=&quot;https://static.mudu.tv/assets/img-console/activity/face/$1.png&quot; />')"></span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="clear"></div>
            </div>
        </div>

        <div class="new-live-detail-home-footer">
            <div
                class="new-live-detail-home-footer-content-text"
                v-if="article && article.parent && article.parent.title"
                @click="goParent(article.parent)">
                <van-image fit="cover" src="/static/bytx/detail_tag_column_icon.svg"></van-image>
                <div>
                    {{ article.parent.title }}
                </div>
                <div><van-icon name="arrow" /></div>
            </div>

            <div class="new-live-detail-home-footer-bottom">
                <div class="new-live-detail-home-footer-bottom-left">
                    <van-grid :column-num="1" :border="false">
                        <van-grid-item
                            icon="/static/img/live/icon_live_meme.svg"
                            @click="showActionMeme = !showActionMeme"
                        />
                    </van-grid>
                </div>
                <div :class="['new-live-detail-home-footer-bottom-center ', comment_text != '' ? 'comment_in' : '']">
                    <van-field
                        round
                        left-icon="/static/img/course/icon_course_text.svg"
                        v-model="comment_text"
                        :placeholder="comment_placeholder == '' ? '写评论…' : comment_placeholder"
                    >
                    </van-field>
                </div>
                <div class="new-live-detail-home-footer-bottom-right">
                    <van-grid :column-num="3" :border="false" v-if="comment_text == ''">
                        <div v-if="is_manager">
                            <van-grid-item
                                @click="favorite()"
                                v-if="article.isFavorite"
                                icon="/static/img/course/icon_course_favorite_on_20.svg"
                                text="已收藏"
                            />
                            <van-grid-item @click="favorite()" v-else icon="/static/bytx/collection.svg" text="收藏" />
                        </div>
                        <van-grid-item @click="showDialog" icon="/static/bytx/Inquiries.svg" text="去问诊" />
                        <van-grid-item @click="goWechat()" icon="/static/bytx/customer-service.svg" text="客服" />
                        <div v-if="!is_manager">
                            <van-grid-item
                                class="more-actions"
                                icon="/static/img/live/icon_live_more.svg"
                                @click="showAction = !showAction"
                            />
                        </div>
                    </van-grid>

                    <div class="live-detail-home-footer-right-btn" v-if="comment_text">
                        <van-button
                            type="danger"
                            size="medium"
                            color="#0FB7AD"
                            style="width:100%"
                            @click="createComment"
                            round
                        >
                            发送
                        </van-button>
                    </div>
                </div>
            </div>

            <div class="live-detail-home-footer-bottom" v-if="showAction">
                <van-divider />
                <van-grid :column-num="is_manager ? 3 : 2" :border="false">
                    <van-grid-item
                        icon="/static/img/course/icon_course_download.svg"
                        text="资料下载"
                        @click="showDownload = true"
                    />
                    <van-grid-item
                        @click="favorite()"
                        v-if="live.isFavorite"
                        icon="/static/img/course/icon_course_favorite_on_20.svg"
                        text="已收藏"
                    />
                    <van-grid-item
                        @click="favorite()"
                        v-else
                        icon="/static/img/course/icon_course_favorite_off_20.svg"
                        text="收藏"
                    />
                    <van-grid-item text="发送图片" v-if="is_manager">
                        <template slot="icon">
                            <van-uploader :after-read="afterRead" accept="*">
                                <img
                                    width="20"
                                    style="margin-bottom: 5px;margin-top: 3px"
                                    src="http://-gobroad.com/static/two/upload_img.svg"
                                    alt=""
                                />
                            </van-uploader>
                        </template>
                    </van-grid-item>
                </van-grid>
                <van-divider />
                <van-number-keyboard safe-area-inset-bottom />
            </div>
            <div class="live-detail-home-footer-bottom" v-if="showActionMeme">
                <van-divider />
                <van-grid :column-num="10" :border="false">
                    <van-grid-item
                        @click="choose_meme(index)"
                        :icon="'http://static.mudu.tv/assets/img-console/activity/face/' + index + '.png'"
                        v-for="index in 75"
                        :key="index"
                    />
                </van-grid>
                <van-divider />
                <van-number-keyboard safe-area-inset-bottom />
            </div>
        </div>

        <van-overlay :show="showShareDialog" @click="showShareDialog = false">
            <div class="share-box">
                <div class="block">请点击 “...”，再点击发送给朋友 | <span>知道啦</span></div>
                <div class="share-box-bottom">
                    <img src="/static/bytx/detail_forward_2_img.png" alt="" />
                </div>
            </div>
        </van-overlay>

        <Consult ref="Refconsult"></Consult>
    </div>
</template>

<script>
import Interface from '@/util/interface'
import articleDetailSkeleton from '@/skeleton/articleDetailSkeleton'
import checkLogin from '../../../mixins/checkLogin'
import ExpertInfo from '@/components/expertInfo'
import { Consult } from '@/components/overlay'
import {LocationHref} from '@/util/common'

export default {
    name: 'article-detail',
    mixins: [checkLogin],
    components: {
        'article-detail-skeleton': articleDetailSkeleton,
        ExpertInfo,
        Consult
    },
    data() {
        return {
            id: 0,
            value: '',
            active: '',
            category_id: 0,
            category_child_id: 0,
            banners: [],
            categories: [],
            categories_child: [],
            recommend: [],
            list: [],
            column: [],
            article: {},
            comment: [],
            comment_text: '',
            loading: true,
            share_data: {},
            showShareDialog: false,
            htmlUrl: '',
            isShow: false,
            status: '',
            comment_id: 0,
            to_user_id: 0,
            comment_placeholder: '写评论',
            user_id: 0,
            showAction: false,
            showActionMeme: false,
            showActionScribe: false,
            is_manager: true
        }
    },
    methods: {
        goParent(row) {
            this.$router.push({ name: 'article-column', params: { id: row.id } })
        },
        choose_meme(index) {
            this.comment_text += index < 10 ? '\\x' + index : '\\x' + index
        },
        goWechat() {
            LocationHref('https://work.weixin.qq.com/kfid/kfc80e2e65a20c7e4b8')
        },
        showDialog() {
            this.$refs.Refconsult.overlayShow = true
        },
        fetch(scene) {
            if (scene === 'article') {
                Interface.getData('get', Interface.article.detail + '/' + this.id).then(res => {
                    this.article = res.data
                    if(this.article.need_auth == 1){
                        this.addInfo("article")
                    }
                    setTimeout(() => {
                        this.loading = false
                    }, 500)
                    if (this.article) {
                        Interface.getShareInfo(this, this.article.title, this.article.cover_img, this.article.desc)
                    }
                })
            } else if (scene === 'comment') {
                let params = {
                    content_id: this.id,
                    comment_type: 2,
                    page: 1,
                    pageSize: 999
                }
                Interface.getData('get', Interface.comment, params).then(res => {
                    if (res.code == 0) {
                        if (res.data.list) this.comment = res.data.list
                    }
                })
            } else if (scene === 'footprint') {
                let params = {
                    id: this.id,
                    type: 2
                }
                Interface.getData('post', Interface.footprint, params).then(res => {})
            } else if (scene === 'share') {
                let params = {
                    content_id: this.id,
                    type: 2
                }
                Interface.getData('get', Interface.share, params).then(res => {
                    this.htmlUrl = res.data.post_img_url
                })
            }
        },
        changeCategory() {
            this.fetch('article')
        },
        favorite() {
            Interface.getData('get', Interface.article.favorite + '/' + this.id).then(res => {
                if (res.code == 0) {
                    this.article.isFavorite = !this.article.isFavorite
                }
            })
        },
        checkUserLogin() {
            this.userLoginCheck()
        },
        createComment() {
            if (!this.userLoginCheck()) {
                return
            }

            if (this.comment_text == '') {
                return
            }
            let params = {
                content_id: this.id,
                comment_type: 2,
                content: this.comment_text
            }
            if (this.comment_id != 0) {
                params.comment_id = +this.comment_id
            }
            if (this.to_user_id != 0) {
                params.to_user_id = +this.to_user_id
            }
            Interface.getData('post', Interface.comment, params).then(res => {
                if (res.code == 0) {
                    this.$toast.success('发送成功')
                    this.fetch('comment')
                    this.goComment()
                    this.comment_text = ''
                    this.comment_placeholder = '写评论'
                    this.comment_id = 0
                    this.to_user_id = 0
                    this.showActionMeme = false
                }
            })
        },
        reComment(item) {
            this.comment_placeholder = '回复' + item.nickname
            this.comment_id = item.id
        },
        reCommentChild(item) {
            this.comment_placeholder = '回复' + item.nickname
            this.comment_id = item.comment_id
            this.to_user_id = item.user_id
        },
        pointLikeComment(item) {
            Interface.getData('get', Interface.pointLikeComment + item.id).then(res => {
                if (res.code == 0) {
                    item.isLike = !item.isLike
                    if (item.isLike) {
                        item.like_count += 1
                    } else {
                        item.like_count -= 1
                    }
                }
            })
        },
        goComment() {
            this.$el.querySelector('.comment').scrollIntoView()
        },
        openShareData() {
            this.showShareDialog = true
        },
        setCurrentUrl: () => {
            let url = location.href.replace(/&wx=[-]{}/g, '')
            window.history.replaceState({}, document.title, url)
        }
    },
    created() {
        this.setCurrentUrl()
        this.id = this.$route.params.id
        this.fetch('article')
        this.fetch('comment')
        this.fetch('footprint')
        this.fetch('share')
    }
}
</script>

<style lang="scss">
@import './index';
@import '../../../components/comment';
</style>



// WEBPACK FOOTER //
// src/views/article/detail/index.vue